import { render, staticRenderFns } from "./custom-field-definition.vue?vue&type=template&id=7decb4ab"
import script from "./custom-field-definition.vue?vue&type=script&lang=js"
export * from "./custom-field-definition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports